<template>
  <div id="app" :class="{'wide': isWideScreen, 'with-modal': showsModal}">
    <header id="app-header" class="app-header"><span>Fiduciary Connect</span></header>
    <main id="app-main" class="auto-height">
      <Navigation
        v-if="showNavigationBar"
        @showTooltip="showTooltipHandler(...arguments)"
        @hideTooltip="hideTooltipHandler()"
      >
      </Navigation>
      <router-view
        @showTooltip="showTooltipHandler(...arguments)"
        @hideTooltip="hideTooltipHandler()"
      >
      </router-view>
    </main>
    <app-footer v-if="showFooter" />
    <toolTip
      v-if="showTooltip"
      :positionX="tooltipPosition.x"
      :positionY="tooltipPosition.y"
      :content="tooltipInfo"
      :orientation="tooltipOrientation"
      :size="tooltipSize"
    />
    <notification />
  </div>
</template>

<script>
import svg4everybody from 'svg4everybody';
import { mapState } from 'vuex';

import ToolTip from '@/components/atoms/ToolTip';
import Navigation from '@/components/atoms/Navigation';
import AppFooter from '@/components/atoms/AppFooter';

// support SVG in IE
svg4everybody();

export default {
  name: 'app',
  components: {
    ToolTip,
    Navigation,
    AppFooter,
  },
  data() {
    return {
      showTooltip: false,
      tooltipPosition: {
        x: 0,
        y: 0,
      },
      tooltipInfo: [],
      tooltipOrientation: '',
      tooltipSize: '',
    };
  },
  computed: {
    ...mapState({
      footerHeight: (state) => state.system.config.footer.height,
      showModal: (state) => state.fullscreenModal.show,
      // The navigation bar displaying is determined in the router.beforEach method
      // The routes that hide the navigation bar should be defined in
      // the property internalProcessRouteNames into the @/config/default-config.json fole
      showNavigationBar: (state) => state.system.config.navigation.show,
      showFooter: (state) => state.system.config.footer.show,
      isInternalProcessLayout: (state) => state.system.config.isInternalProcessLayout,
    }),
    isWideScreen() {
      return this.isInternalProcessLayout;
    },
    showsModal() {
      return this.showModal;
    },
    styles() {
      return {
        minHeight: `calc(100% - 40px - ${this.footerHeight}px)`,
      };
    },
  },
  methods: {
    showTooltipHandler(event, status, orientation, size) {
      this.showTooltip = true;
      // Move the tooltip slightly away from the cursor pointer
      this.tooltipPosition.x = event.clientX + 5;
      this.tooltipPosition.y = event.clientY + 5;
      this.tooltipInfo = status;
      this.tooltipOrientation = orientation;
      this.tooltipSize = size;
    },
    hideTooltipHandler() {
      this.showTooltip = false;
    },
  },
};
</script>

<style lang="scss">
#app {
  @include mds-font-reset();
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  min-height: 100vh;
  max-width: calc(100vw - 120px);
  width: 100%;
  padding: 0;
  overflow-y: hidden;
  &.wide {
    max-width: 100%;
  }
  &.with-modal {
    height: 100vh;
  }
  > main:not(.tooltip), header:not(.tooltip), article:not(.tooltip) {
    display: flex;
    width: 100%;
    flex-direction: row;
    aside, article {
      display: flex;
      flex: 1 1 auto;
      > section {
        flex: 1 1 100%;
      }
    }
  }
  main {
    flex: 1;
  }
  .auto-height {
    min-height: calc(100% - 90px);
  }
  .app-header {
    color: $fc-main-color;
    height: 40px;
    line-height: 40px;
    justify-content: center;
    @include mds-level-3-heading();
  }
}
body {
  margin: 0;
  /* overflow-y: hidden; */
  /**
   * CSSFix: Browser move viewport when hidden radio button and checkbox takes focus
   **/
  .mds-form__radio-button input[type="radio"],
  .mds-form__checkbox input[type="checkbox"] {
    display: none;
    outline: none;
  }
  .mds-menu .mds-popover {
    z-index: 1000;
  }
}
</style>
